<template>
  <!-- displays a list of news as carousel or as list. Set displayModeCarousel to true to display it as a carousel -->
  <div>
    <!-- 15 = space between cards -->
    <!-- 25 = add offset for navigation items  -->
    <fin-scroll-carousel v-if="displayModeCarousel"
                         :itemSize="itemSize + 16"
                         :items="value">
      <template #default="{item}">
        <fin-news-item :hideImage="hideImage"
                       :largeCard="largeCard"
                       :showItemTitle="showItemTitle"
                       :showItemTeaser="showItemTeaser"
                       :value="item"
                       :width="itemSize"
                       class="d-inline-block fill-height"/>
      </template>
    </fin-scroll-carousel>

    <div v-else>
      <div v-for="(item, index) in value"
           :key="item.id"
           class="article-list">
        <router-link :to="{name: 'newsDetail', params: {id: item.id}}">
          <fin-news-item :value="value[index]"
                         :hideImage="hideImage"
                         :largeCard="largeCard"
                         :show-background="false"
                         :show-bookmark="false"
                         :show-border="false"
                         :show-box-shadow="false"
                         :show-divider="index !== value.length - 1"
                         :showItemTeaser="showItemTeaser"
                         :showItemTitle="showItemTitle"
                         :width="width"
                         class="d-inline-block my-3"/>
        </router-link>
      </div>
      <div v-intersect="{
            handler: onIntersect,
          }"/>
    </div>
  </div>
</template>

<script>
import finNewsItem from '@/components/common/news/NewsItem.vue'
import finScrollCarousel from '@/components/common/ScrollCarousel'

export default {
  name: 'FinNewsItems',
  components: {
    finScrollCarousel,
    finNewsItem
  },
  props: {
    displayModeCarousel: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    hideImage: {
      type: Boolean
    },
    /** The layout of a large card contains two columns:
     *      on the left: image
     *      on the right: source-datum-category, title, teaser
     * The layout of a 'normal' card contains one column
     *      source-datum-category, image, title, teaser
     * */
    largeCard: {
      type: Boolean
    },
    /** set to true to display the title */
    showItemTitle: {
      type: Boolean
    },
    /** set to true to display the teaser */
    showItemTeaser: {
      type: Boolean
    },
    width: {
      type: Number,
      default: undefined
    },
  },
  data() {
    return {
      itemSize: 324,
      heightLarge: 470,
      heightSmall: 250,
      offset: 15,
    }
  },
  methods: {
    onIntersect(entries, observer) {
      if (entries[0].intersectionRatio >= 0.5) {
        this.$emit('loadMoreNews')
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
